import { useTranslation } from "react-i18next";
import { HStack, VStack } from "@/shared/ui/Stack";
import { NewVoteList } from "./NewVoteList/NewVoteList";
import { NewVoteSwitch } from "./NewVoteSwitch";
import style from "./newVote.module.css";
import { StartVoteButton } from "./StartVoteButton/StartVoteButton";
import { TimeController } from "./TimeController/TimeController";
import { VotesController } from "./VotesController/VotesController";

interface NewVoteProps {
    onStart: () => void;
}

export function NewVote({ onStart }: NewVoteProps) {
    const { t } = useTranslation();
    return (
        <div className={style.newVoteWrapper}>
            <VStack fullWidth>
                <HStack fullWidth gap={8} className={style.newVoteControllersWrapper}>
                    <VotesController />

                    <TimeController />
                </HStack>

                <HStack fullWidth gap={16} className={style.newVoteSwitchesWrapper}>
                    <NewVoteSwitch name={t("vote.switchOnePerItem")} />
                </HStack>

                <NewVoteList />
            </VStack>

            <StartVoteButton onStart={onStart} />
        </div>
    );
}
